import { getData, postData, putData } from '../services/apiService';
import { Organization } from '../types/Organization';
import { UserRole, UserRoleHostOrg } from '../types/UserRole';

export const getOrganizations = async () => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await getData('/organizations', {});
    } catch (error) {
      console.error('Failed to fetch organizations:', error);
    }
  };

  export const getOrganizationById = async (organization_id: string): Promise<Organization | null> => {
    try {
      // Dynamically insert hostId into the URL path
      const response = await getData(`/organizations/${organization_id}`, {});
      return response.data as Organization;
    } catch (error) {
      console.error('Failed to fetch organizations:', error);
    }
    return null
  };

  export const getOrganizationByCode = async (code: string): Promise<Organization | null> => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await getData(`/organizations/code/${code}`, {});  // The API call is unchanged
      // Assuming the API returns an array of events in response.data
      return response.data as Organization;  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch organization:', error);
      return null;  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };
  

  export const createOrganization = async (organization: Organization): Promise<{organization: Organization, role: UserRole} | null> => {
    try {
      // Dynamically insert hostId into the URL path
      const response = await postData(`/organizations`, organization);
      return {organization: response.data.organization as Organization, role: response.data.role as UserRole };
    } catch (error) {
      console.error('Failed to create organizations:', error);
      throw error;
    }
  };
  

  export const updateOrganization = async (organization_id: string, organization: Organization): Promise<Organization | null> => {
    try {
      const response = await putData(`/organizations/${organization_id}`, organization);
      return response.data as Organization;
    } catch (error) {
      console.error('Failed to update organization:', error);
    }
    return null
  };

    export const getRolesForOrganization = async (organization_id: string): Promise<UserRoleHostOrg[]> => {
      try {
        const response = await getData(`/organizations/${organization_id}/roles`, {});
        return response.data as UserRoleHostOrg[];
      } catch (error) {
        console.error('Failed to fetch roles:', error);
      }
      return []
    };